import './src/styles/global/main.scss';